import { render, staticRenderFns } from "./tabCustomer.vue?vue&type=template&id=c8608386&scoped=true&"
import script from "./tabCustomer.vue?vue&type=script&lang=js&"
export * from "./tabCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8608386",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8608386')) {
      api.createRecord('c8608386', component.options)
    } else {
      api.reload('c8608386', component.options)
    }
    module.hot.accept("./tabCustomer.vue?vue&type=template&id=c8608386&scoped=true&", function () {
      api.rerender('c8608386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabCustomer.vue"
export default component.exports